import React from 'react'
import s from './listDownload.module.css'
import Btn from '../../components/buttons-v2/buttons'
import { DownloadFolder } from '../../svg/download_folder'

const ListDownload = props => {
  return (
    <div
      id='GTM-MOD-MEP-SECTION-TP-DOC-INFO'
      className={`${s.listDownloadItem} ${props.className} bg-white border-1 border-gray-0 brad-4 flex direction-column direction-row@lg items-center justify-center justify-around@lg tw-py-8 tw-py-6@lg tw-px-2 tw-px-8@lg tw-my-2 w-100 w-45@md w-100@lg shadow-2`}
    >
      <div id='GTM-MOD-MEP-SECTION-TP-DOC-INFO-CONTAINER' className={`flex direction-column direction-row@lg justify-start items-center w-60 w-60@lg m-auto tw-m-0@lg`}>
        <div className={'w-15@lg'}>
          <DownloadFolder fill={props.icoColor} className={`${s.listDownIco} tw-mb-4 tw-mb-0@lg tw-mr-4@lg`} />
        </div>
        <div id='GTM-MOD-MEP-SECTION-TP-DOC-INFO-CONTAINER-TITLE' className={`w-85@lg`}>
          {props.preTitle && (
          <span className='db center left@lg font-family-secondary c-orange-0 fw-7 tw-f-16 tw-f-16@lg'>
            {props.preTitle}
          </span>
          )}
          <span className='db center left@lg font-family-secondary c-gray--4 fw-7 tw-f-16 tw-f-16@lg'>
            {props.title}
          </span>
          {props.size && (
            <span className='db center left@lg font-family-secondary c-gray--5 fw-4 tw-f-14 tw-f-14@lg tw-mt-2'>
              {props.size}
            </span>
          )}
        </div>
      </div>

      <Btn
        type='link'
        href={props.download}
        title={props.title}
        GTM={true}
        GTMOption={{section:props.GTMOption.section, sub_sec:props.GTMOption.sub_section, option:'', location:props.GTMOption.location,  }}
        target='_blank'
        size='medium'
        label={props.btnLabel}
        color='turquoise'
        className={`font-family-secondary tw-f-16 tw-px-8 tw-px-4@lg tw-py-3 m-auto ml-auto@lg tw-mr-0@lg tw-mt-8 tw-mt-0@lg block center w-60 w-80@md w-15@lg brad-5`}
      />

    </div>
  )
}

ListDownload.defaultProps = {
  preTitle: '', // PreTitulo
  title: '', // Titulo
  link: '', // Link
  icoColor: '#45494E', // Color del icono
  btnLabel: 'Descargar',  // Label del Btn
  className: '', // Clase CSS
  type:'',
  GTMOption: {section:'', sub_section:'', option:'', location:''}
}

export default ListDownload
